import { Type } from "class-transformer";
import { VatReleaseReasonSource } from "../../company/vat-release-reason-source";
import { InventoryEffect } from "../../inventory/inventory-effect";
import { SaleDocumentUpdateItemDTO } from "./sale-document-item.dto";
import { SaleDocumentDTO } from "./sale-document.dto";

export class SaleUpdateDocumentDTO extends SaleDocumentDTO {
	public adjustedDocumentId?: number;
	public adjustmentReasonId?: number;
	public advanceId?: number | null;
	public firstAdvanceDocumentId?: number | null;
	public firstAdvanceDocumentVersion?: string | null;
	public marginSchemeId?: number;
	public numberingId?: number;
	public originalDocumentId?: number;
	public originalDocumentVersion?: string;
	public implementedDocumentId?: number;
	public implementedDocumentVersion?: string;
	public vatReleaseReasonId?: number;
	public vatReleaseReasonCustomName: string;
	@Type(() => SaleDocumentUpdateItemDTO)  public items: SaleDocumentUpdateItemDTO[];
	public customDueDate?: boolean;
	public customDueDateDescription: string | null;
	public vatReleaseReasonSource?: VatReleaseReasonSource;
	public inventoryEffect?: InventoryEffect | null;
	public adjustPaymentDate: boolean;
}
